var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHangerMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 43,
    viewBox: "0 0 53 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7 37.7792L29.125 20.8479V18.4592C33.4563 17.1729 36.475 12.7629 35.5038 7.82795C34.8213 4.3892 32.0913 1.52795 28.6525 0.740449C22.6675 -0.624551 17.3125 3.9167 17.3125 9.6917H22.5625C22.5625 7.51295 24.3213 5.7542 26.5 5.7542C28.6788 5.7542 30.4375 7.51295 30.4375 9.6917C30.4375 11.8967 28.6263 13.6817 26.4213 13.6292C25.0038 13.6029 23.875 14.8104 23.875 16.2279V20.8479L1.30001 37.7792C-0.72124 39.3017 0.35501 42.5042 2.87501 42.5042H50.125C52.645 42.5042 53.7213 39.3017 51.7 37.7792ZM10.75 37.2542L26.5 25.4417L42.25 37.2542H10.75Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangerMobile);
export default __webpack_public_path__ + "static/media/hangerMobile.5cc383c13929407a90b767e7456ae2a6.svg";
export { ForwardRef as ReactComponent };